import React, { useEffect, useState } from "react"

import * as S from "./gallery.styles"
import CustomImage from "../../components/custom-image/custom-image.component"

const Gallery = ({ items }) => {
  const [images, setImages] = useState([])

  useEffect(() => {
    let galleryImages = []
    let allImages = []

    for (let i = 0; i < items.length; i++) {
      if (items[i].images.length === 3) {
        for (let j = 0; j < items[i].images.length; j++) {
          galleryImages[j] = items[i].images[j]
        }
      }

      allImages.push(galleryImages)
      galleryImages = []
    }

    setImages(allImages)
  }, [])

  return (
    <S.Gallery>
      {images &&
        images.length > 0 &&
        images.map((item, index) => (
          <>
            {index % 2 === 0 ? (
              <S.GridContainer container>
                <S.Left item xs={12} sm={6}>
                  <CustomImage img={item[0].image} />
                </S.Left>
                <S.Right item xs={12} sm={6}>
                  <CustomImage img={item[1].image} />
                  <CustomImage img={item[2].image} />
                </S.Right>
              </S.GridContainer>
            ) : (
              <S.GridContainer container>
                <S.RightRev item xs={12} sm={6}>
                  <CustomImage img={item[0].image} />
                  <CustomImage img={item[1].image} />
                </S.RightRev>
                <S.LeftRev item xs={12} sm={6}>
                  <CustomImage img={item[2].image} />
                </S.LeftRev>
              </S.GridContainer>
            )}
          </>
        ))}
    </S.Gallery>
  )
}

export default Gallery
